import React, { useEffect, useState } from 'react';
import Header from '../components/header/boardHeader'
import Profile from '../components/profile/profileAdded';
import ProfileDetailsBoard from '../components/profileDetails/profileDetailsBorad';
import { useNavigate } from "react-router-dom";
import { Buffer } from "buffer";
import { Oval } from "react-loader-spinner";
import Snackbar from "@mui/material/Snackbar";
import MuiButton from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { useSelector, useDispatch } from "react-redux";
import { getAllBoards } from "../redux/actions/boardActions";

// Import supabase configuration
import supabase from "../config/supabase";
import axios from "axios";
import { nanoid } from "nanoid";

function CandidateAdded() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    
    const initialState = useSelector((state) => state.boards);

    const [candidate, setCandidate] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [boards, setBoards] = useState([]);
    const [showBoards, setShowBoards] = useState(false);
    const [selectedBoard, setSelectedBaord] = useState("");
    const [boardId, setBaordId] = useState("");
    const [saveButtonStyle, setSaveButtonStyle] = useState("w-32 bg-pink-1");
    const [showMessage, setShowMessage] = useState(false);
    const [message, setMessage] = useState("");
    const [showButton, setShowButton] = useState(false);
    const [selectedProfiles, setSelectedProfiles] = useState([]);
    const [profilesAddedInBoard, setProfilesAddedInBoard] = useState([]);

    useEffect(() => {
        var candidateData = JSON.parse(localStorage.getItem('Candidate'));
        setCandidate(candidateData);
        dispatch(getAllBoards());
    }, [])

    useEffect(() => {
        setBoards(initialState);
        initialState.length && setSelectedBaord(initialState[0].name);
    }, [initialState]);

    const toCandidates = () => {
        localStorage.removeItem('Candidate')
        navigate('/')
    }

      // Function for profile addition
    const addSelection = async () => {
        setShowLoader(true);
        // Get board id
        var boardId = boards.find((b) => b.name == selectedBoard).id;
        setBaordId(boardId);

        var dataObject = await getAllBoardProfiles(boardId);

        var resultedProfiles = dataObject.profiles;
        var available = dataObject.alreadyBoardAvailable;
        resultedProfiles = resultedProfiles || [];
        var selected = [];

        // Loop over profiles

        // Find the selected profile and check if already in selected board
        var included = false;
        resultedProfiles &&
        resultedProfiles.forEach((rp) => {
            if (rp.id === candidate.id) {
            included = true;
            }
        });
        // Add to selection

        var obj = {
        id: candidate.id,
        status: "New",
        message: "",
        meetingTime: "",
        endMeetingTime: "",
        rate: candidate.expected_hourly_rate,
        paymentFrequency: "Hourly"
        };
        
        !included && selected.push(obj);

        setSelectedProfiles(selected);

        selected = [...resultedProfiles, ...selected];

        setProfilesAddedInBoard(selected);

        if (resultedProfiles.length <= 0 && !available) {
          let masked_url = window.location.origin + "/redirect?" + nanoid().substring(0, 6);

          const { data, error } = await supabase
              .from("board_profiles")
              .insert({ board: boardId, profiles: selected, masked_url:masked_url, });

          if (data && data.length) {
              setSaveButtonStyle("w-32 bg-black-1");
              setShowMessage(true);
              setMessage("Profile is added successfully.");
              setTimeout(function () {
              setShowButton(false);
              setSaveButtonStyle("w-32 bg-pink-1");
              }, 3000);
          }
        } else if (selected.length - resultedProfiles.length > 0) {
        const { data, error } = await supabase
            .from("board_profiles")
            .update({ profiles: selected })
            .match({ board: boardId });

        if (data && data.length) {
            setSaveButtonStyle("w-32 bg-black-1");
            setShowMessage(true);
            setMessage("Profile is added successfully.");
            setTimeout(function () {
            setShowButton(false);
            setSaveButtonStyle("w-32 bg-pink-1");
            }, 3000);
            getScreenShot(boardId);
        }
        } else {
        setShowMessage(true);
        setMessage("Profile already exists in board.");
        setTimeout(function () {
            setShowMessage(false);
        }, 3000);
        }
        setShowLoader(false);
    };

      // get all boards profiles
    const getAllBoardProfiles = async (boardId) => {
        const { data, error } = await supabase
        .from("board_profiles")
        .select("*")
        .match({ board: boardId });

        if (data && data.length > 0) {
        var dataObject = {
            profiles: data[0].profiles,
            alreadyBoardAvailable: true,
        };
        return dataObject;
        } else {
        var dataObject = {
            profiles: [],
            alreadyBoardAvailable: false,
        };
        return dataObject;
        }
    };

    const getScreenShot =  async(Id) => {
        var id = Buffer.from(Id,
          "utf-8"
        ).toString("base64");
    
       await axios
       .get(`https://shot.screenshotapi.net/screenshot?token=R5XWFXS-QF2MD5V-N6CF9CZ-F7Z08EF&url=https://ats-search.netlify.app/sharedProfiles?id=${id}&width=1040&height=750&delay=5000`)
       .then( async(response) => {  
        const Image = response.data.screenshot;
        // setScreenShotImage(Image);
        const { data, error } = await supabase
            .from("board_profiles")
            .update({ profiles_screenshot: Image })
            .match({ board: Id });    
    
       })
       .catch(function (error) {
         console.log("error in taking screenshot", error);
       });
    };

    const addToBoard = async() => {
        setShowBoards(true);
    }

      // undo profile
    const undoProfileAddition = async () => {
        // Delete profiles
        // Get a copy of all profiles in board
        var profiles = profilesAddedInBoard;

        // Get copy of currently selected profiles
        var selected_profiles = selectedProfiles;

        var selected = [];
        profiles.forEach((profile) => {
        var check = false;
        // Find the selected profile and push to selected
        selected_profiles.forEach((p) => {
            if (p.id == profile.id) {
            check = true;
            }
        });
        !check && selected.push(profile);
        });

        const { data, error } = await supabase
        .from("board_profiles")
        .update({ profiles: selected })
        .match({ board: boardId });

        setShowButton(false);
        setShowMessage(false);
        setSaveButtonStyle("w-32 bg-pink-1");
    };

      // Change board
    const changeBoard = (event) => {
        setSelectedBaord(event.target.value);
    };

    const action = (
        <React.Fragment>
          {saveButtonStyle !== "w-32 bg-pink-1" && (
            <MuiButton
              color="secondary"
              size="small"
              onClick={() => undoProfileAddition()}
            >
              UNDO
            </MuiButton>
          )}
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => setShowMessage(false)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
    );
    
  return (
    <div className='w-full h-full'>
        <div className="sticky top-0 z-50">
          <Header addCandidate={true} />
        </div>
        <div className='grid grid-cols-12'>
            {showLoader && (
              <div className="fixed flex items-center justify-center z-50 w-full h-full top-0 bg-white-1">
                {/* Add backdrop */}
                
                <div className={`relative flex`}>
                  <Oval
                      color="white"
                      secondaryColor="grey"
                      height="40"
                      width="60"
                    />
                    <div className="flex items-center">Hold Tight-just getting this page ready.</div>
                </div>
              </div>
            )}
            <Snackbar
                open={showMessage}
                onClose={() => setShowMessage(false)}
                autoHideDuration={3000}
                message={message}
                action={action}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            />
            <div className='md:col-span-6 omd-1:hidden bg-[#E5E5E5] h-screen flex justify-center items-center'>
                <div className='grid md:grid-rows-2'>
                    <div className='flex justify-center text-center items-end mb-4 text-xl md:text-[32px] font-bold'>New candidate has been added!</div>
                    <div className=''>
                        <Profile profile={candidate} addCandidate={true} />
                    </div>
                    <div className='flex justify-center'>
                        <div className="font-semibold flex text-blue-4 mt-10 cursor-pointer " onClick={() => toCandidates()}>View other candidates
                            <svg className="ml-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12.172 12L9.343 9.172l1.414-1.415L15 12l-4.243 4.243-1.414-1.415z" fill="rgb(32,78,207)"/></svg>
                        </div>
                    </div>
                </div>
                <div className="omd-1:hidden absolute inset-40-1 bottom-3/4 z-10">
                  <img src="/reverseArrow.png" />
                </div>
            </div>
            <div className='md:col-span-6 omd-1:bg-[#F1F2F5] col-span-12 md:h-screen scrollbar md:overflow-y-scroll relative'>
                <div className="md:hidden absolute mt-14 ml-5">
                  <img src="/downArrow.svg" />
                </div>
                <div className='md:hidden my-7 flex justify-center text-center mx-auto text-2xl md:text-[32px] w-9/12 font-bold'>New candidate has been added!</div>
                <ProfileDetailsBoard  profile={candidate} addCandidate={true} addToBoard={addToBoard} boards={boards} showBoards={showBoards} changeBoard={changeBoard} saveButtonStyle={saveButtonStyle} selectedBoard={selectedBoard} addSelection={addSelection} toCandidates={toCandidates} />
            </div>
        </div>
    </div>
  )
}

export default CandidateAdded